const footerGroups = [
  {
    title: "快速导航",
    links: [
      { label: "热播排行", href: "#ranking" },
      { label: "高分剧单", href: "#rating" },
      { label: "题材选剧", href: "#genres" },
      { label: "追更日历", href: "#schedule" }
    ]
  },
  {
    title: "发现更多",
    links: [
      { label: "编辑精选", href: "#editors" },
      { label: "新剧上线", href: "#new" },
      { label: "常见问题", href: "#faq" },
      { label: "订阅追更提醒", href: "#subscribe" }
    ]
  },
  {
    title: "题材入口",
    links: [
      { label: "高分爱情韩剧", href: "#genres" },
      { label: "烧脑悬疑韩剧", href: "#genres" },
      { label: "治愈生活剧", href: "#genres" },
      { label: "复仇爽剧", href: "#genres" }
    ]
  }
];

export default function Footer() {
  return (
    <footer className="w-full bg-secondary-950">
      <div className="mx-auto w-full max-w-6xl px-4 py-14 md:px-6">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-5">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-tv-2-line text-lg" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-lg font-bold text-background-50">韩剧TV</span>
            </div>
            <p className="mt-4 max-w-md font-body text-sm leading-relaxed text-background-200">
              韩剧TV 是一个面向中文观众的韩剧导航站，聚合正在更新的最新韩剧与高分口碑剧单，
              按热度、评分、题材分类整理，帮你在最短时间内找到合口味的那一部。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              {["最新韩剧", "高分剧单", "热播推荐", "好看排行"].map((t) => (
                <span
                  key={t}
                  className="rounded-full bg-background-50/10 px-3 py-1 font-label text-xs text-background-100"
                >
                  {t}
                </span>
              ))}
            </div>
          </div>

          {footerGroups.map((group) => (
            <div key={group.title}>
              <h4 className="font-heading text-sm font-semibold text-background-50">
                <a href="#top" className="hover:text-accent-300">
                  {group.title}
                </a>
              </h4>
              <ul className="mt-4 space-y-2.5">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="font-body text-sm text-background-300 transition-colors hover:text-accent-300"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-background-50/10 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="font-body text-xs text-background-400">
            © 2026 韩剧TV · 本站为剧集信息聚合导航，内容与播出信息以各平台实际为准。
          </p>
          <p className="font-body text-xs text-background-400">
            剧集简介仅用于介绍与搜索，不提供任何影视资源存储。
          </p>
        </div>
      </div>
    </footer>
  );
}